import styled from 'styled-components/macro';

export const StyledTruncated = styled.p`
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ lineHeight }) => lineHeight};
  display: -webkit-box;
  max-width: 100%;
  max-height: ${({ fontSize, rowSize, lineHeight }) =>
    `calc(${fontSize}px * ${lineHeight} * ${rowSize})`};
  -webkit-line-clamp: ${({ rowSize }) => rowSize};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin: 0;
`;
